import {useOutletContext} from 'react-router-dom';
import {RootPageContext} from './types';

export function useRootPageContext() {
	return useOutletContext<RootPageContext>();
}
